import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import useRoles from "src/hooks/user/useRoles";
import { useProject } from "../ProjectProvider";
import SKULibrary from "../sku_library/SKULibrary";
import Kitting from "../kitting/Kitting";
import GroupedItems from "../grouped_items/GroupedItems";

export default function CatalogTab({ onClose, activeView, onChange }) {
  const { project } = useProject();
  const canAccessSkuLibrary = !useRoles(["employee", "viewer"]);
  const showGroupedItems = !!project?.groupedAssets || !!project?.groupedSerializedAssets;

  const showKitting = !!project?.kitting;

  const initialView = canAccessSkuLibrary
    ? "sku_library"
    : showKitting
    ? "kitting"
    : showGroupedItems
    ? "grouped_items"
    : null;

  const currentView = ["sku_library", "kitting", "grouped_items"].includes(activeView)
    ? activeView
    : initialView;

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      if (onChange) {
        onChange(newView);
      }
    }
  };

  const showToggles =
    [canAccessSkuLibrary, showKitting, showGroupedItems].filter(Boolean).length > 1;

  if (!currentView) return null;

  const tabs = showToggles ? (
    <Box display="flex" mb={2} borderBottom={1} borderColor="divider">
      <Tabs
        value={currentView}
        onChange={handleViewChange}
        aria-label="catalog view"
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            minWidth: "fit-content",
            px: 2,
          },
        }}
      >
        {canAccessSkuLibrary && <Tab value="sku_library" label="SKU Library" />}
        {showKitting && <Tab value="kitting" label="Kitting" />}
        {showGroupedItems && <Tab value="grouped_items" label="Grouped Items" />}
      </Tabs>
    </Box>
  ) : null;

  return (
    <Box display="flex" flexDirection="column" flex={1} minHeight={0} height="100%" overflow="hidden">
      {currentView === "sku_library" && canAccessSkuLibrary && (
        <SKULibrary title={tabs} onClose={onClose} />
      )}
      {currentView === "kitting" && showKitting && <Kitting title={tabs} onClose={onClose} />}
      {currentView === "grouped_items" && showGroupedItems && (
        <GroupedItems title={tabs} onClose={onClose} />
      )}
    </Box>
  );
}
